import get from 'lodash/get';
import {GeoJSON} from 'ol/format';
import {Vector} from 'ol/layer';
import VectorSource from 'ol/source/Vector';

import * as c from '../../config';

import styles from './styles';

const geoJSONFormat = new GeoJSON();

function readFeaturesFromProps(props, featureSourceName) {
	const geoJson = get(
		props,
		`featureSources['${featureSourceName}'].data`,
		false
	);

	if (geoJson) {
		try {
			return geoJSONFormat.readFeatures(geoJson, {
				dataProjection: 'EPSG:4326',
				featureProjection: 'EPSG:3857',
			});
		} catch (e) {
			console.error(
				'readFeaturesFromState: geojson format parsers error',
				e
			);
			return [];
		}
	} else {
		console.error('readFeaturesFromState: feature source not found');
		return [];
	}
}

export function updateVectorSource(vectorSource, props, featureSourceName) {
	vectorSource.clear();
	vectorSource.addFeatures(readFeaturesFromProps(props, featureSourceName));
}

export function getVectorData(props) {
	const vectorSources = {
		[c.FEATURE_SOURCE_ALL]: new VectorSource({
			wrapX: false,
			features: readFeaturesFromProps(props, c.FEATURE_SOURCE_ALL),
		}),
	};

	const layers = {
		[c.FEATURE_SOURCE_ALL]: new Vector({
			source: vectorSources[c.FEATURE_SOURCE_ALL],
			style: (feature, resolution) =>
				styles(feature, resolution, 'normal'),
			updateWhileAnimating: true,
			updateWhileInteracting: true,
			renderBuffer: 400,
		}),
	};

	return {vectorSources: vectorSources, layers: layers};
}
